import { useCallback, useEffect, useState } from 'react';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getActionRequiredCount } from 'src/shared/services/memberAutogiroStatus';

/**
 * Antal medlemmar med autogiro som betalsätt där dragningen inte blir av: medgivandet saknas, är
 * ej godkänt, har fel eller är makulerat. Används både för siffran på fliken och för filtret i
 * listan, så att de alltid visar samma tal.
 */
export const useActionRequiredBadge = (enabled = true): [number, () => void] => {
  const { dateStamp } = useGlobals();
  const [count, setCount] = useState(0);

  const fetch = useCallback(() => {
    if (!enabled) return;

    getActionRequiredCount()
      .then((res) => setCount(res.data ?? 0))
      .catch(() => undefined);
  }, [enabled]);

  useEffect(() => {
    fetch();
  }, [fetch, dateStamp]);

  return [count, fetch];
};
